module.exports = "<div [ngClass]=\"['authorization-inputs', classes]\">\n  <div id=\"card-stripe-uniq\" class=\"form-input\" class=\"field\"></div>\n</div>\n"